import { render } from "./carPrivacyProtocol.vue?vue&type=template&id=14701430"
const script = {}

import "./carPrivacyProtocol.vue?vue&type=style&index=0&id=14701430&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__